import { motion } from 'framer-motion';
import { Play } from 'lucide-react';
import { Link } from 'react-router';

import { cn } from '@/lib/utils';

import { useGetAppContext } from '@/services/context/queries';

export const SignInOrDashboard = () => {
  const { data: appContext, isLoading } = useGetAppContext({ retry: false });

  if (isLoading) return <div className="w-[103px]" />;

  const user = appContext?.user;

  const buttonClasses =
    'flex items-center gap-2 font-medium border-b-2 pb-1 transition-all duration-300 text-base text-foreground decoration-primary border-primary';

  const iconClasses = cn('size-4 text-greenhorn-400');

  const fillClasses = '#1CEFA5';

  return (
    <motion.div
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.2 }}
    >
      {user ? (
        <Link to="/dashboard">
          <span className={buttonClasses}>
            <span>Dashboard</span>
            <Play fill={fillClasses} className={iconClasses} />
          </span>
        </Link>
      ) : (
        <div className="flex items-center gap-6">
          <div className="flex items-center gap-2">
            <a href="/login">
              <span className="flex items-center gap-2 font-medium border-b-2 pb-1 transition-all duration-300 text-base text-foreground decoration-transparent border-transparent hover:decoration-primary hover:border-primary">
                <span>Sign In</span>
              </span>
            </a>
          </div>
          <div className="flex items-center gap-2">
            <a href="/register">
              <span className={buttonClasses}>
                <span>Get Started</span>
                <Play fill={fillClasses} className={iconClasses} />
              </span>
            </a>
          </div>
        </div>
      )}
    </motion.div>
  );
};
